<template>
  <section class="container">
    <!-- 下拉列表 -->
    <section class="list_box">
      <!-- @click="changeSelect(dictList,'serviceType')" -->
      <section class="list_item" >
        <section class="list_item_left">
          <span class="xin">*</span>
          <span class="label">服务项目</span>
        </section>
        <section class="list_item_right">
          <!-- <span class="placeholder" v-if="!serviceName"  v-else>请选择服务项目</span> -->
          <span class="value">{{serviceName}}</span>
          <!-- <img class="yjt" src="../../assets/images/icon_indicator_next.png" /> -->
        </section>
      </section>
      <template v-for="item in intServRegs">
        <!-- 输入框 -->
        <section class="list_item" v-if="item.regType == 1" :key="item.regKey">
          <section class="list_item_left">
            <span class="xin">*</span>
            <span class="label">{{item.regName}}</span>
          </section>
          <section class="list_item_right">
            <input
              class="input"
              type="text"
              :placeholder="'请输入'+item.regName"
              v-model="item.regValue"
              @blur="blur"
            />
          </section>
        </section>
        <!-- 时间选择  pickTime-->
        <section @click="changeSelect('',item.regKey)" class="list_item" v-if="item.regType == 3 || item.regType == 4" :key="item.regKey">
          <section class="list_item_left">
            <span class="xin">*</span>
            <span class="label">{{item.regName}}</span>
          </section>
          <section class="list_item_right">
            <span class="placeholder" v-if="item.regValue == 0 | !item.regValue">请选择</span>
            <span class="value" v-else>{{item.regValue}}</span>
            <img class="yjt" src="../../assets/images/icon_indicator_next.png" />
          </section>
        </section>
      </template>
      <section class="list_item">
        <section class="list_item_left">
          <span class="xin">*</span>
          <span class="label">联系人</span>
        </section>
        <section class="list_item_right">
          <input class="input" type="text" placeholder="请输入联系人" v-model="userName" @blur="blur" />
        </section>
      </section>
      <section class="list_item">
        <section class="list_item_left">
          <span class="xin">*</span>
          <span class="label">手机号</span>
        </section>
        <section class="list_item_right">
          <input class="input" type="tel" placeholder="请输入手机号" v-model="phone" @blur="blur" />
        </section>
      </section>
    </section>
    <!-- 备注 -->
    <section class="remarks">
      <p>备注</p>
      <textarea @blur="blur" placeholder="请输入" v-model="remark"></textarea>
    </section>
    <common-footer class="button">
      <mt-button class="footer_btn btn_default" @click="submit">提交</mt-button>
    </common-footer>
    <mt-popup v-model="popupVisible" position="bottom" class="popupBox">
      <mt-picker
        class="picker"
        :slots="dataList"
        :visible-item-count="5"
        :show-toolbar="true"
        :item-height="44"
        ref="picker"
      >
        <div class="picker_wrap">
          <div class="picker_btn" @click="popupVisible=false">取消</div>
          <div class="picker_btn2" @click="handleConfirm">确认</div>
        </div>
      </mt-picker>
    </mt-popup>
    <yd-datetime
      style="display:none;"
      ref="datetime"
      @input="dateChange"
      type="datetime"
      v-model="date"
      start-date="1919-01-01"
    ></yd-datetime>
  </section>
</template>

<script>
import util from "../../utils/util";
import commonFooter from "../../components/commonFooter";
import { mapState } from "vuex";
import {
  getIntServTemplateByMarketId,
  getServiceTypeDict,
  getIntServTemplateById,
  saveIntServOrder
} from "../../utils/api.js";
export default {
  name: "appointForm",
  components: {
    commonFooter
  },
  data() {
    return {
      intServRegs: [],
      dictList: [], //服务项目
      companyList: [], //企业列表
      serviceName: "",
      serviceIndex:0,
      id:'',
      serviceType: "",
      templateId:'',
      userName: "",
      phone: "",
      remark:"",
      dataList: [
        {
          flex: 1,
          values: [],
          className: "slot1",
          textAlign: "center"
        }
      ],
      date: util.formatTime(new Date(), 10),
      popupVisible: false
    };
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  created() {
    // 设置姓名跟手机号
    let query = this.$route.query;
    if(query.serviceName){
      this.serviceName =decodeURIComponent(query.serviceName)
    }
    if(query.serviceType){
      this.serviceType =decodeURIComponent(query.serviceType)
    }
    if(query.id){
      this.id =query.id;
    }
    // var serviceName =encodeURIComponent(this.obc.name) ;
    // var serviceType =encodeURIComponent(this.obc.type);

    if (this.common.userTenantInfo && this.common.userTenantInfo.phone) {
      this.userName = this.common.userTenantInfo.userName;
      this.phone = this.common.userTenantInfo.phone;
    } else {
      this.userName = this.common.userInfo.userName;
      this.phone =
        this.common.userInfo.account || this.common.userTenantInfo.phone;
    }
    // 设置企业信息
    this.companyList = this.common.userTenantInfoList;
    this.getIntServTemplateByMarketId();
    //this.getServiceTypeDict(); //服务类型
  },
  methods: {
    blur() {
      setTimeout(function() {
        var scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    toMyAppoint() {
      this.$router.push("/myAppoint");
    },
    changeSelect(data, type) {
      if(type == 'intserv_order_time'){
        this.$refs.datetime.open();
      }else{
        this.popupVisible = true;
        if (type == "serviceType") {
          let newA = [];
          data.forEach(item => {
            newA.push(item.dictName);
          });
          this.dataList[0].values = newA;
        }else if(type == 'intserv_company_name'){
          let newA = [];
          this.companyList.forEach(item => {
            newA.push(item.company);
          });
          this.dataList[0].values = newA;
        }
        this.selectType = type;
      }
    },
    dateChange(val) {
      let intServRegs = this.intServRegs;
      for (var index in intServRegs) {
        if (intServRegs[index].regKey === "intserv_order_time") {
          intServRegs[index].regValue = val;
        }
      }
    },
    // 获取数据
    getIntServTemplateByMarketId() {
      util.showLoading();
      //getIntServTemplateByMarketId({}).then(res => {
      getIntServTemplateById({
        templateId:this.id
      }).then(res => {
        console.log(res);
        util.hideLoading();
        if (res.res.code === 10000 && res.body) {
          let data = res.body.intServRegs || [];
          // 设置默认企业信息

          data.forEach(item => {
            item.regValue = '';
            if (item.regKey == "intserv_company_name") {
              let hasDefault = false,
                companyName = "";
              this.companyList.forEach(cur => {
                console.log(cur);
                if (cur.isDeafult == "1") {
                  hasDefault = true;
                  companyName = cur.company;
                }
              });
              if (hasDefault) {
                item.regValue = companyName;
              } else {
                item.regValue = this.companyList[0].company;
              }
            }
          });
          this.templateId = this.id;
          //res.body.intServTemplate.id;
          this.intServRegs = data;
          console.log("this.intServRegs   ====  ")
          console.log(this.intServRegs)
          // util.hideLoading();
        } else {
          util.hideLoading();
          util.showToast(res.res.msg);
        }
      });
    },
    getServiceTypeDict() {
      getServiceTypeDict({}).then(res => {
        console.log(res);
        if (res.res.code === 10000 && res.body) {
          this.dictList = res.body.dictList || [];
          if (this.dictList.length > 0) {
            this.serviceName = this.dictList[this.serviceIndex].dictName;
            this.serviceType = this.dictList[this.serviceIndex].dictValue;
          }
          util.hideLoading();
        } else {
          util.hideLoading();
          util.showToast(res.res.msg);
        }
      });
    },
    handleConfirm() {
      this.popupVisible = false;
      let val = this.$refs.picker.getValues()[0];
      // 服务项目
      if (this.selectType == "serviceType") {
        this.serviceName = val;
        this.dictList.forEach(item => {
          if (item.dictName == val) {
            this.serviceType = item.dictValue;
          }
        });
      }else if(this.selectType == "intserv_company_name"){//企业信息
        this.intServRegs.forEach(item=>{
          if(item.regKey == this.selectType){
            item.regValue = val
          }
        })
      }
    },
    submit() {
      for(var i in this.intServRegs){
        if(!this.intServRegs[i].regValue){
          if(this.intServRegs[i].regType == 1){
            util.showToast('请输入'+this.intServRegs[i].regName)
          }else if(this.intServRegs[i].regType == 3){
            util.showToast('请选择'+this.intServRegs[i].regName)
          }
          return;
        }
      }
      if(!this.userName){
        util.showToast('请输入联系人')
        return;
      }
      if(!this.phone){
        util.showToast('请输入手机号')
        return;
      }else if(this.phone.length != 11){
        util.showToast('请输入正确的手机号')
        return;
      }
      util.showLoading()
      let params = {
        serviceType:this.serviceName,
        phone:this.phone,
        userName:this.userName,
        templateId:this.templateId,
        remark:this.remark
      }
      let intservRegItems = [];
      this.intServRegs.forEach(item=>{
        intservRegItems.push({regDicName:item.regName,regDicValue:item.regValue})
      })
      params.intservRegItems = intservRegItems;
      saveIntServOrder(params).then(res=>{
          util.hideLoading()
        if(res.res.code === 10000){
          util.showToast('提交成功')
          this.$router.replace("/myAppoint");
        }else{
          util.showToast(res.res.msg)
        }
      })
      // this.$router.push("/myAppoint");
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  background: #eee;
}
.list_box {
  margin-bottom: 14px;
}
.list_item {
  .borderB();
  background: #fff;
  height: 100px;
  .flex();
  align-items: center;
  justify-content: space-between;
  &:last-child {
    border: 0;
  }
  .list_item_left {
    width: 200px;
    margin-left: 20px;
    .flex();
    .xin {
      color: #fc3f56;
      font-size: 28px;
      display: block;
      margin-right: 4px;
    }
    .label {
      font-size: 28px;
      color: rgba(51, 51, 51, 1);
    }
  }
  .list_item_right {
    height: 100px;
    margin-right: 28px;
    flex: 1;
    .flex();
    align-items: center;
    .placeholder {
      flex: 1;
      color: #c9c9c9;
      font-size: 28px;
    }
    .value {
      flex: 1;
      color: #333;
      font-size: 28px;
    }
    .yjt {
      width: 32px;
      height: 32px;
      display: block;
    }
    input {
      height: 94%;
      flex: 1;
    }
  }
}

// 备注
.remarks {
  background: #fff;
  margin-bottom: 120px;
  padding: 28px 30px;
  p {
    height: 40px;
    font-size: 28px;
    color: rgba(51, 51, 51, 1);
    line-height: 40px;
    margin-bottom: 14px;
  }
  textarea {
    display: block;
    font-size: 28px;
    min-height: 172px;
    width: 100%;
  }
}
.footer_btn {
  width: 100%;
  height:76px;
  color: #fff;
  border-radius: 4px;
  background: @color17;
  font-size: 32px;
}
</style>